import { ClientSignupForm } from "../../../components/auth/ClientSignupForm";

export default function ClientSignupScreen() {
  return <ClientSignupForm />;
}
